import React from 'react'

const ModalTerms = React.lazy(
  () => import('../../molecules/modalTerms/modalTerms')
)
const ModalLogin = React.lazy(
  () => import('../../molecules/modal-login/modal-login')
)
const ModalRedeem = React.lazy(
  () => import('../../molecules/modal-redeem/modal-redeem')
)
const ModalUpdateData = React.lazy(
  () => import('../../molecules/moda-update-data/moda-update-data')
)
const ModalVideo = React.lazy(
  () => import('../../molecules/modal-video/modal-video')
)

const ModalComfirmExit = React.lazy(
  () => import('../../molecules/modal-confirm-exit/modal-confirm-exit')
)
const ModalComfirm = React.lazy(
  () => import('../../molecules/modal-confirm/modal-confirm')
)
const ModalOpinion = React.lazy(
  () => import('../../molecules/modal-opinion/modal-opinion')
)
const ModalShare = React.lazy(
  () => import('../../molecules/modal-share/modal-share')
)

const ModalRevive = React.lazy(
  () => import('@/components/molecules/modal-revive/modal-revive')
)
const ModalBuy = React.lazy(
  () => import('@/components/molecules/modal-buy/modal-buy')
)

const ModalsMap: { [key: string]: React.JSX.ElementType } = {
  terms: ModalTerms,
  login: ModalLogin,
  updatedata: ModalUpdateData,
  redeem: ModalRedeem,
  video: ModalVideo,
  exit: ModalComfirmExit,
  confirm: ModalComfirm,
  opinion: ModalOpinion,
  share: ModalShare,
  revive: ModalRevive,
  buy: ModalBuy,
}
export const getModal = (modalId: string, props: any = {}) => {
  if (ModalsMap.hasOwnProperty(modalId)) {
    const Modal = ModalsMap[modalId]
    return <Modal {...props} />
  }

  return <div>NOT FOUND {modalId}</div>
}
